/**
 * @generated SignedSource<<9edc0bce57ace771356567c576f1c981>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSpacesDataStarredSpacesQuery$variables = Record<PropertyKey, never>;
export type useSpacesDataStarredSpacesQuery$data = {
  readonly spaces: {
    readonly __typename: "PaginatedSpaceList";
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null | undefined;
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly name: string | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSpacesDataStarredSpacesQuery = {
  response: useSpacesDataStarredSpacesQuery$data;
  variables: useSpacesDataStarredSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "favourite",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 30
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "current"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpacesDataStarredSpacesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSpacesDataStarredSpacesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
    "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
    "metadata": {},
    "name": "useSpacesDataStarredSpacesQuery",
    "operationKind": "query",
    "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
  }
};
})();

(node as any).hash = "519f9d02cbfeb4f3f118821c02e3a7b9";

export default node;
